module.exports = __webpack_public_path__ + "assets/img/starter_frame.9778b2ad.jpg";